import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseIcon, InformationCircleIcon, LockOpenIcon, LockClosedIcon, XIcon, PlusIcon } from '../../../../assets/svgs/icons'
import styles from './styles.module.css'
import { InlineColorPicker } from './InlineColorPicker'

export const ColorSelector = ({ isOpen, onClose, onSave, presetsProp = [] }) => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState('select')
  const [colors, setColors] = useState([
    { hex: null, locked: false },
    { hex: null, locked: false },
    { hex: null, locked: false },
    { hex: null, locked: false },
    { hex: null, locked: false }
  ])

  const [showPicker, setShowPicker] = useState(false)
  const [pickerIndex, setPickerIndex] = useState(null)

  // const [presets, setPresets] = useState([
  //   // Exemplo de predefinições - você pode receber isso via props ou API
  //   { id: 1, colors: ['1A5F7A', '8B9DC3', 'A8E6CF', '8B9DC3', 'A8E6CF'] },
  //   { id: 2, colors: ['00D9FF', '9B59B6', '2ECC71', 'D7BDE2', '2ECC71'] },
  //   { id: 3, colors: ['FFB347', '2C3E50', '000000', '1A5F7A', '8B4513'] },
  //   { id: 4, colors: ['9B59B6', '8E44AD', 'D2B48C', 'E8D5E8', '000000'] },
  //   { id: 5, colors: ['FFD700', '00FF00', 'FF00FF', 'FF0000', 'F5F5DC'] },
  //   { id: 6, colors: ['FFB6C1', '00FFFF', '00FF00', 'ADFF2F', '00FF00'] },
  //   { id: 7, colors: ['FF7F50', 'DDA0DD', '9370DB', '00FFFF', '8B4513'] },
  //   { id: 8, colors: ['1C1C1C', '8B008B', '0000FF', 'F0E6FF', 'E6E6FA'] },
  //   { id: 9, colors: ['1A5F7A', '8B9DC3', 'A8E6CF', '8B9DC3', 'A8E6CF'] },
  //   { id: 10, colors: ['FF69B4', 'FFD700', '0000FF', 'E6E6FA', '98FB98'] },
  // ])

  const [presets, setPresets] = useState(presetsProp || [])


  useEffect(() => {
    if (presetsProp && presetsProp.length > 0) {
      setPresets(presetsProp)
    }
  }, [presetsProp])


  if (!isOpen) return null

  const handleToggleLock = (index) => {
    const newColors = [...colors]
    if (!newColors[index] || newColors[index].hex === null) return
    newColors[index].locked = !newColors[index].locked
    setColors(newColors)
  }

  const handleRemoveColor = (index) => {
    const newColors = [...colors]
    newColors[index].hex = null
    setColors(newColors)
  }

  const handleOpenPicker = (index) => {
    if (showPicker === true || colors[index]?.hex !== null) {
      setShowPicker(false)
      setPickerIndex(null)
      return
    }
    setShowPicker(true)
    setPickerIndex(index)
  }

  const handleApplyPreset = (presetColors) => {
    const newColors = presetColors.map((hex) => ({
      hex: hex,
      locked: false
    }))
    // Garantir que sempre tenha 5 cores
    while (newColors.length < 5) {
      newColors.push({ hex: null, locked: false })
    }
    setColors(newColors)
    // Voltar para a aba de seleção após aplicar
    setActiveTab('select')
  }

  const handleSave = () => {
    const validColors = colors.filter(color => color && color.hex !== null)
    if (onSave) {
      onSave(validColors)
    }
    onClose()
  }

  return (
    <div className={styles.container}>
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{t('chatsocket.color.modal_title')}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon color="#000" size="20" />
          </button>
        </div>

        {/* Tabs */}
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${activeTab === 'select' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('select')}
          >
            {t('chatsocket.color.tab_select')}
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'presets' ? styles.tabActive : ''}`}
            onClick={() => setActiveTab('presets')}
          >
            {t('chatsocket.color.tab_presets')}
          </button>
        </div>

        {/* Color List ou Predefinições */}
        {activeTab === 'select' ? (
          <>
            <div className={styles.colorList}>
              {colors.map((color, index) => (
                <div key={index} style={{position: 'relative', width: '100%', height: '100%'}}>
                  {showPicker && pickerIndex === index && (
                    <InlineColorPicker
                      isOpen={true}
                      initialColor={color.hex ? `#${color.hex}` : '#000000'}
                      onColorChange={(hex) => {
                        const newColors = [...colors]
                        newColors[index] = { hex, locked: false }
                        setColors(newColors)
                      }}
                      onClose={() => {
                        setShowPicker(false)
                        setPickerIndex(null)
                      }}
                    />
                  )}
      
                  {color.hex === null ? (
                    <div className={`${styles.colorItemContainer} ${index === 0 ? styles.firstColorItem : ''} ${index === colors.length - 1 ? styles.lastColorItem : ''}`} key={index}>
                      <div className={styles.colorItem}>
                        <div style={{position: 'relative', width: '100%', height: '100%', borderRadius: '0px'}}>
                          <button  className={styles.AddColorItem} onClick={() => handleOpenPicker(index)}>
                            <span
                              className={styles.AddColorItemText}>{t('chatsocket.color.add_color')}</span>
                            <PlusIcon width={14} height={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={`${styles.colorItemContainer} ${index === 0 ? styles.firstColorItem : ''} ${index === colors.length - 1 ? styles.lastColorItem : ''}`} key={index}>
                      <button
                        onClick={() => handleOpenPicker(index)}
                        key={index}
                        className={styles.colorItem}
                        style={{ backgroundColor: `#${color.hex}`, cursor: 'pointer', borderRadius: '0px'}}
                      >
                        <span className={styles.colorHex}>{color.hex}</span>
                        <button
                          className={styles.iconButton}
                          onClick={() => handleToggleLock(index)}
                          title={color.locked ? t('chatsocket.color.unlock_color') : t('chatsocket.color.lock_color')}
                        >
                          {color.locked ? <LockClosedIcon width={20} height={20} /> : <LockOpenIcon width={20} height={20} />}
                        </button>
                        <button
                          className={styles.iconButton}
                          onClick={() => handleRemoveColor(index)}
                          title={t('chatsocket.color.remove_color')}
                        >
                          <XIcon width={30} height={30} />
                        </button>
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Info Message */}
            <div className={styles.infoBox}>
              <InformationCircleIcon width={20} height={20} />
              <p className={styles.infoText}>
          {t('chatsocket.color.random_info')}
              </p>
            </div>
          </>
        ) : (
          <div className={styles.presetsContainer}>
            {presets.map((preset) => (
              <button
                key={preset.id}
                className={styles.presetItem}
                onClick={() => handleApplyPreset(preset.colors)}
              >
                <div className={styles.presetColors}>
                  {preset.colors.map((hex, colorIndex) => (
                    <div
                      key={colorIndex}
                      className={styles.presetColorStrip}
                      style={{ backgroundColor: `#${hex}` }}
                    />
                  ))}
                </div>
              </button>
            ))}
          </div>
        )}

        {/* Save Button */}
        <button className={styles.saveButton} onClick={handleSave}>
          {t('chatsocket.color.save_colors')}
        </button>
      </div>
    </div>
  )
}